import angular from 'angular';
import pocketLintComponent from './pocketLintComponent';

angular.module('sh.pocketLint', []).directive('shPocketLint', pocketLintComponent);
